import '../../assets/stylesheets/scss/main_application.scss';
import initApplication from '../dashboard/application';

initApplication();
